/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { generateDocsUrl } from '../../../ia/util/docs';

export const links = {
  CONVERSATION_RESPONSE_LEARN_MORE_LINK: generateDocsUrl(
    '//watson-assistant?topic=watson-assistant-conversational-search'
  ),
  CONVERSATIONAL_SEARCH_CITATION_URL: '#'
};
